"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastLocation = void 0;
var _hooks = require("../../../../../hooks");
var _Tooltip = require("../../../../../UI/Tooltip");
var _A = require("../../../../../UI/A");
var _LastLocationButton = require("./partials/LastLocationButton");
var _jsxRuntime = require("react/jsx-runtime");
var LastLocation = function LastLocation(props) {
  var currentPageUrl = props.currentPageUrl,
    lastLocation = props.lastLocation,
    optionalData = props.optionalData,
    _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: view === 'horizontal' || isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_LastLocationButton.LastLocationButton, {
      view: view,
      currentPageUrl: currentPageUrl,
      lastLocation: lastLocation,
      optionalData: optionalData
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
      position: "top",
      isInteractive: true,
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LastLocationButton.LastLocationButton, {
        view: view,
        currentPageUrl: currentPageUrl,
        lastLocation: lastLocation,
        optionalData: optionalData
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_A.A, {
        color: "primary",
        size: "small",
        to: currentPageUrl,
        target: "_blank",
        category: "bookTile",
        label: "lastPageLink",
        optionalData: optionalData,
        children: lastLocation
      })
    })
  });
};
exports.LastLocation = LastLocation;